import {autoserializeAs} from "dcerialize";

export enum ReferenceLinkKind {
  AppStore = "appStore",
  Website = "website",
}

export class ReferenceLink {
  @autoserializeAs(() => String)
  public readonly kind: ReferenceLinkKind;
  @autoserializeAs(() => String)
  public readonly url: string;
}
